<template>
  <zaproo-accordion-item
    v-model:opened="openedState[filter.key]"
    class="filter-sidebar-wrapper border-b border-zinc-200"
  >
    <template #title>
      <div class="font-semibold">
        {{ $t(filter.label) }}
      </div>
    </template>

    <slot />
  </zaproo-accordion-item>
</template>

<script setup lang="ts">
import { KlevuFilter } from "~/modules/klevu/types";
import { ZaprooKlevuFilterManager } from "~/modules/klevu/classes/ZaprooKlevuFilterManager";
import { useFilterSidebarOpenState } from "~/modules/catalog/composables/useFilterSidebarOpenState";

const { openedState } = useFilterSidebarOpenState();

const props = defineProps<{
  filter: KlevuFilter;
  filterManager: ZaprooKlevuFilterManager;
}>();

if (props.filterManager.hasSelected(props.filter.key)) {
  openedState.value[props.filter.key] = true;
}
</script>
<style lang="scss">
.zaproo-accordion-item.filter-sidebar-wrapper {
  .zaproo-accordion-item-action {
    @apply p-4;
  }
}
</style>
